import { Button, Form, Col, Offcanvas, Card, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import WebService from "../../../utility/WebService";
import { Label } from "../../../components/Label/Label";
import HelperService from "../../../utility/HelperService";
import { EMAIL_REGEX } from "../../../utility/constants";
import Select from 'react-select';
import PlotDatePicker from "../../../components/PlotDatePicker/PlotDatePicker";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../components/Grid/Grid";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
};

const headers: GridHeader[] = [
    {
        title: "Registration Date",
        class: "text-left",
    },
    {
        title: "Buyer name",
        class: "text-left",
    },
    {
        title: "Buyer Phone",
        class: "text-left",
    },
    {
        title: "Seller name",
        class: "text-left",
    },
    {
        title: "Seller Phone",
        class: "text-left",
    }
];

const ManageUnit = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, getValues, register, reset, setValue } = useForm({});
    const watchAllFields = watch();
    const passwordRegex = /^^(?=.*[A-Za-z0-9])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/;
    const [isShowNewPassword, setIsShowNewPassword] = useState<boolean>(false);
    const [isShowConfirmPassword, setIsShowConfirmPassword] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [projectOptions, setProjectOptions] = useState<any[]>([]);

    const [registrationData, setRegistrationData] = useState<any>([]);
    const [unitData, setUnitData] = useState<any>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<any[]>([]);



    useEffect(() => {
        if (props.isShow && props.data) {
            getUnitDetail(props.data.uuid);
        }
    }, [props.isShow, props.data]);

    const getUnitDetail = (uuid: string) => {
        setIsLoading(true);
        WebService.getAPI({
            action: `get-booking-unit-detail/${uuid}`,
        }).then((res: any) => {
            setIsLoading(false);
            setUnitData(res.booked_unit);
            reset(res.booked_unit);
            setValue("is_registration", res.booked_unit.is_registration ? true : false);
            setValue("is_resale", res.project_unit.is_resale ? true : false);
            setValue("unit_id", res.project_unit.id || "");
            setValue("booking_id", res.booked_unit.id || "");
            setRegistrationData(res.booked_unit.registration);
            if (res.booked_unit.registrations && res.booked_unit.registrations.length > 0) {
                const data = res.booked_unit.registrations[res.booked_unit.registrations.length - 1];
                setValue("registration_number", data.registration_number || "");
                setValue("registration_date", data.registration_date ? new Date(data.registration_date) : null);
                setValue("transfer_from", data.transfer_from || "");
                setValue("transfer_from_phone", data.transfer_from_phone || "");
                setValue("transfer_to", data.transfer_to || "");
                setValue("transfer_to_phone", data.transfer_to_phone || "");
                setValue("registration_id", data.id || "");
                let row: GridRow[] = [];
                for (let i of res.booked_unit.registrations) {
                    if (i.transfer_from) {
                        let columns: GridColumn[] = [];
                        columns.push({ value: i.registration_date ? HelperService.getFormatedDate(i.registration_date) : "N/A" });
                        columns.push({ value: i.transfer_to ? i.transfer_to : "N/A" });
                        columns.push({ value: i.transfer_to_phone ? HelperService.getFormattedContact(i.transfer_to_phone) : "N/A" });
                        columns.push({ value: i.transfer_from ? i.transfer_from : "N/A" });
                        columns.push({ value: i.transfer_from_phone ? HelperService.getFormattedContact(i.transfer_from_phone) : "N/A" });
                        row.push({ data: columns });
                    }
                }
                setRows(row);
            }
        }).catch((err: any) => {
            setIsLoading(false);
            toast.error(err.message || "Failed to fetch unit details.");
        });
    };

    const handleFormSubmit = (data: any) => {
        if (data.is_registration) {
            data.transfer_from_phone = Number(data.transfer_from_phone.toString().replaceAll("-", ""));
            data.transfer_to_phone = Number(data.transfer_to_phone.toString().replaceAll("-", ""));
        };

        WebService.postAPI({ action: "update-unit-status", body: data, id: "changePassword-btn" })
            .then((res: any) => {
                toast.success(res.message);
                closeModal(true);
            })
            .catch(() => { });
    };

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        setValue('first_name', '');
        setValue('last_name', '');
        setValue('email', '');
        setValue('phone', '' as any);
        setValue('password', '');
        setValue('comfirm_password', '');
        setValue('projects_id', []);
        setValue('is_registration', false);
        setValue('is_resale', false);
        setValue('registration_number', '');
        setValue('registration_date', null);
        setValue('transfer_from', '');
        setValue('transfer_from_phone', '');
        setValue('transfer_to', '');
        setValue('transfer_to_phone', '');
        setIsEdit(false);
        setIsShowNewPassword(false);
        setIsShowConfirmPassword(false);
    };

    return (
        <>
            <Offcanvas show={props.isShow} className='modal-xl' onHide={props.isClose} placement="end">
                <Offcanvas.Header closeButton><Offcanvas.Title>Update Unit</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >

                        <Row className="mb-3">

                            {unitData && unitData.booking && (
                                <Row className="mb-3">
                                    <Col lg={6}>
                                        <Form.Group>
                                            <Form.Label>Customer :-</Form.Label>
                                            {"  "}
                                            {unitData.booking.customer_name} ({unitData.booking.customer_phone})
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group>
                                            <Form.Label>Agent :-</Form.Label>
                                            {"  "}
                                            {unitData.booking.agent_name} ({unitData.booking.agent_phone})
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                            <Col lg={6}>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="custom-switch"
                                    label="Is Registration Complete"
                                    {...register("is_registration", { value: false })} // Default value is false
                                    className="mb-3"
                                    disabled={unitData?.is_registration ? true : false}
                                    checked={watchAllFields.is_registration || false}
                                />
                            </Col>

                            <Col lg={6}>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="custom-switch"
                                    label="Is Available For Resale"
                                    {...register("is_resale", { value: false })} // Default value is false
                                    className="mb-3"
                                    checked={watchAllFields.is_resale || false}
                                />
                            </Col>

                            {watchAllFields.is_registration && <>
                                <Col lg={6}>
                                    <Controller
                                        control={control}
                                        name="registration_number"
                                        // rules={{ required: watchAllFields.is_registration ? "Please Enter Registration Number" : false }}
                                        rules={{ required: false, pattern: { value: /^[a-zA-Z0-9\s]+$/, message: "Registration Number can only contain alphanumeric characters and spaces." } }}
                                        render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                            <div className="mb-2">
                                                <Label title="Registration Number" showStar={false} />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Registration Number"
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={watchAllFields.registration_number}
                                                />
                                                {(errors["registration_number"]?.message || Boolean(errors["registration_number"]?.message) || (isTouched && !watchAllFields.registration_number)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.registration_number?.message?.toString() || "Please Enter Registration Number."} modeError={true} />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>

                                <Col lg={6}>
                                    {/* registration_date */}
                                    <Controller
                                        control={control}
                                        name="registration_date"
                                        rules={{ required: watchAllFields.is_registration ? true : false, }}
                                        render={({ field: { onChange } }) => (
                                            <Form.Group className="mb-2">
                                                <Label title="Registration Date" showStar={true} />
                                                <div className="input-group mb-1">
                                                    <div className="col-12 form-group">
                                                        <PlotDatePicker
                                                            selected={watch("registration_date") ? new Date(watch("registration_date")) : null}
                                                            onChange={(date: any) => onChange(date)}
                                                            placeholderText="Select Date"
                                                        />
                                                        {errors.registration_date && (
                                                            <Label
                                                                title={"Please Select Date."}
                                                                modeError={true}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        )}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <Controller
                                        control={control}
                                        name="transfer_from"
                                        rules={{ required: false, pattern: { value: /^[a-zA-Z\s]+$/, message: "Seller Name can only contain letters and spaces." } }}
                                        // rules={{ required: watchAllFields.is_registration ? "Please Enter Seller Name" : false }}
                                        render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                            <div className="mb-2">
                                                <Label title="Seller Name" showStar={false} />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Seller Name"
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={watchAllFields.transfer_from}
                                                />
                                                {(errors["transfer_from"]?.message || Boolean(errors["transfer_from"]?.message) || (isTouched && !watchAllFields.transfer_from)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.transfer_from?.message?.toString() || "Please Enter Seller Name."} modeError={true} />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <Controller
                                        control={control}
                                        name="transfer_from_phone"
                                        rules={{ required: false }}
                                        // rules={{ required: watchAllFields.is_registration ? "Please Enter Seller Phone" : false }}
                                        render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                            <div className="mb-2">
                                                <Label title="Seller Phone" showStar={false} />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Seller Phone"
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    onKeyPress={HelperService.allowOnlyNumericValue}
                                                    onKeyUp={(e) => HelperService.contactFormatter(e)}
                                                    value={watchAllFields.transfer_from_phone}
                                                />
                                                {/* {(errors["transfer_from_phone"]?.message || Boolean(errors["transfer_from_phone"]?.message) || (isTouched && !watchAllFields.transfer_from_phone)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.transfer_from_phone?.message?.toString() || "Please Enter Seller Phone."} modeError={true} />
                                                    </div>
                                                )} */}
                                            </div>
                                        )}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <Controller
                                        control={control}
                                        name="transfer_to"
                                        rules={{ required: watchAllFields.is_registration ? "Please Enter Buyer Name" : false, pattern: { value: /^[a-zA-Z\s]+$/, message: "Buyer Name can only contain letters and spaces." } }}
                                        render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                            <div className="mb-2">
                                                <Label title="Buyer Name" showStar={true} />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Buyer Name"
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={watchAllFields.transfer_to}
                                                />
                                                {(errors["transfer_to"]?.message || Boolean(errors["transfer_to"]?.message) || (isTouched && !watchAllFields.transfer_to)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.transfer_to?.message?.toString() || "Please Enter Buyer Name."} modeError={true} />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Controller
                                        control={control}
                                        name="transfer_to_phone"
                                        rules={{ required: watchAllFields.is_registration ? "Please Enter Buyer Phone" : false }}
                                        render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                            <div className="mb-2">
                                                <Label title="Buyer Phone" showStar={true} />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Buyer Phone"
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    onKeyPress={HelperService.allowOnlyNumericValue}
                                                    onKeyUp={(e) => HelperService.contactFormatter(e)}
                                                    value={watchAllFields.transfer_to_phone}
                                                />
                                                {(errors["transfer_to_phone"]?.message || Boolean(errors["transfer_to_phone"]?.message) || (isTouched && !watchAllFields.transfer_to_phone)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.transfer_to_phone?.message?.toString() || "Please Enter Buyer Phone."} modeError={true} />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    />
                                </Col>


                                <Col lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Area</Form.Label>{" "}
                                        <div className="input-group mb-1">
                                            <input
                                                type="text"
                                                className="form-control ps-3 p-2"
                                                placeholder="Area in Square Feet"
                                                {...register("area", { required: false })}
                                                onKeyPress={HelperService.allowOnlyNumericValue}
                                                onBlur={(e) => {
                                                    setValue(
                                                        "total_cost",
                                                        watchAllFields.area *
                                                        watchAllFields.area
                                                    );
                                                }}
                                                value={watchAllFields.area}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </>}
                        </Row>

                        <div className="text-center">
                            <Button variant="dark" className="btn-brand-1 px-5 mt-3 mb-3 me-2" type="submit" id="changePassword-btn" >
                                Save
                            </Button>
                            <Button variant="light" className="btn-brand-1 px-5 mt-3 mb-3" type="button" onClick={() => closeModal(false)} >
                                Close
                            </Button>
                        </div>

                        {rows && rows.length > 0 &&
                            <div className="table-card">
                                <hr />
                                <span className="font-16 font-medium">Registration History </span>
                                <Grid
                                    rows={rows}
                                    headers={headers}
                                    ShowLoader={isLoading}
                                    errorMessage={"No Project Unit Found"}
                                />
                            </div>
                        }



                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default ManageUnit;
